import { Navigate, useLocation } from "react-router-dom";

const ProtectedRoute = ({ children, isAuthenticated, requiredPermission, requiredSection, user }) => {
  const location = useLocation();
  
  if (!isAuthenticated) {
    const returnTo = location.pathname + location.search;
    return <Navigate to={`/login?returnTo=${encodeURIComponent(returnTo)}`} replace />;
  }
  
  if (requiredPermission) {
    if (!user) {
      return null;
    }
    if (!user[requiredPermission]) {
      return <Navigate to="/spark-creator" replace />;
    }
  }
  
  return children;
};

export default ProtectedRoute;
